import React, { Component } from 'react';
import { Bar, Pie } from 'react-chartjs-2';

class ReportPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            barData: []
        }
    }
    preparePiedata = () => {
        const { data } = this.props;
        const pieData = {
            labels: ['Approved Applications', 'Selected Applications', 'Verified', 'Unverified', 'Non Responsive Rate'],
            datasets: [{
                data: [data.approved || 0, data.selected || 0, data.verified || 0, data.unverified || 0, data.nonResponsiveRate || 0],
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#FF5733', '#D4AC0D']
            }]
        };
        return pieData;
    }
    prepareBardata = () => {
        const { data } = this.props;
        const barData = {
            labels: ['Actual', 'New'],
            datasets: [
                {
                    label: 'Free',
                    data: [data.actualFree || 0, data.newFree || 0],
                    backgroundColor: '#FF6384'
                },
                {
                    label: 'Reduced',
                    data: [data.actualReduced || 0, data.newReduced || 0],
                    backgroundColor: '#36A2EB'
                }
            ]
        };
        return barData;
    }

    render() {
        const { data, downloadReport } = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="h5 text-center text-black">Overall Status</div>
                        <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                            <Pie
                                data={this.preparePiedata()}
                                width={100}
                                height={100}
                                options={{
                                    legend: {
                                        display: false // Hide legends
                                    }
                                }} />
                        </div>
                        <div className='table-container' style={{ textAlign: 'center', marginTop: '10px' }}>
                            <table border="2">
                                <tr>
                                    <td>Approved Applications</td>
                                    <td>{`${data.approved || 0}`}</td>
                                </tr>
                                <tr>
                                    <td>Selected Applications</td>
                                    <td>{`${data.selected || 0}`}</td>
                                </tr>
                                <tr>
                                    <td>Verified</td>
                                    <td>{`${data.verified || 0}`}</td>
                                </tr>
                                <tr>
                                    <td>Unverified</td>
                                    <td>{`${data.unverified || 0}`}</td>
                                </tr>
                                <tr>
                                    <td>Non Responsive Rate</td>
                                    <td>{`${data.nonResponsiveRate || 0} %`}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="h5 text-center text-black">Eligibility Changes</div>
                        <div style={{ maxWidth: '300px', margin: '0 auto' }}>
                            <Bar
                                data={this.prepareBardata()}
                                width={100}
                                height={260}
                                options={{
                                    maintainAspectRatio: false,
                                    legend: {
                                        display: false // Hide legends
                                    },
                                    scales: {
                                        y: { beginAtZero: true }
                                    }
                                }}
                            />
                        </div>
                        <div className='table-container' style={{ textAlign: 'center', marginTop: '10px' }}>
                            <table border="2">
                                <tr>
                                    <th className="bg-white"></th>
                                    <th>Free</th>
                                    <th>Reduced</th>
                                </tr>
                                <tr>
                                    <td>Actual</td>
                                    <td>{data.actualFree || 0}</td>
                                    <td>{data.actualReduced || 0}</td>
                                </tr>
                                <tr>
                                    <td>New</td>
                                    <td>{data.newFree || 0}</td>
                                    <td>{data.newReduced || 0}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div className="col-md-4 text-right">
                        <span role='button' className="btn btn-primary" onClick={() => {
                            downloadReport(true)
                        }}>Verification Report <i class="fa fa-download"></i></span>

                    </div>
                </div>

            </div>
        );
    }
}

export default ReportPage;


// WEBPACK FOOTER //
// ./src/components/District/Applications/reportPage.jsx